import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, switchMap, take } from "rxjs";

import { AuthCoreService } from "./auth.service";

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthCoreService);
  const authRequest =  authService.authToken$.pipe(take(1), switchMap((token: string | null) => {
    // If authentication token is not defined, continue with the current request.
    if (token === null) return next(req);

    // Continue with the authed request.
    return next(req.clone({ setHeaders: { Authorization: 'Bearer ' + token } }));
  }));

  return authRequest;
}